import React from 'react';
import Hero from '../../components/ui/Hero';
import ProfileForm from '../../components/profile/ProfileForm';
import { useAuth } from '../../hooks/useAuth';
import { Lock } from 'lucide-react';

const ProfilePage = () => {
  const { user, signIn } = useAuth();

  if (!user) {
    return (
      <div>
        <Hero
          title="Profile Settings"
          description="Manage your account settings and preferences"
          compact
        />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">
            <Lock className="w-12 h-12 text-brand mx-auto mb-4" />
            <h2 className="text-2xl font-bold mb-4">Sign In Required</h2>
            <p className="text-content-secondary mb-6">
              You need to be signed in to view your profile.
            </p>
            <button
              onClick={signIn}
              className="btn-primary"
            >
              Sign In to Continue
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Hero
        title="Profile Settings"
        description="Manage your account settings and preferences"
        compact
      />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="card p-6">
          <ProfileForm />
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;